import React from 'react';
import {
  Row, Col,
} from 'reactstrap';

export default function ProfileCard(props) {
  const {
    name,
    image,
  } = props.profile;
  return (
    <Row>
      <Col>
        <Row className="pt-3">
          <Col>
            {/* <img className="img-fluid rounded-circle profile-image"  */}
            <img className="img-fluid"
            // height='209'
            // width='279'
            src={image} 
            alt={`${name}`}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
